import React from "react";
import { useMutation } from "react-query";
import { archiveGroup, deleteGroup } from "./api";
import DangerZone from "../shared/form/DangerZone";

type EditGroupActionsArgs = {
  archived: boolean;
  can: {
    archive: boolean;
    destroy: boolean;
  };
  slug: string;
  name: string;
};

export default function EditGroupActions({
  archived,
  can,
  slug,
  name,
}: EditGroupActionsArgs) {
  const { mutate: onDeleteGroup } = useMutation(deleteGroup, {
    onSuccess: ({ redirect }) => {
      toastr.success(I18n.t("groups.destroy.success", { group: name }));
      window?.Turbo?.visit(redirect, {
        action: "replace",
        target: document.documentElement,
        historyChanged: true,
      });
    },
  });

  const { mutate: onArchiveGroup } = useMutation(archiveGroup, {
    onSuccess: ({ archived, redirect }) => {
      toastr.success(
        I18n.t(
          archived
            ? "js.groups.group.successfully_archived"
            : "js.groups.group.successfully_unarchived",
          { group_name: name },
        ),
      );
      window?.Turbo?.visit(redirect, {
        action: "replace",
        target: document.documentElement,
        historyChanged: true,
      });
    },
  });

  return (
    <DangerZone
      title={I18n.t(
        archived ? "js.groups.edit.is_archived" : "js.groups.edit.do_archive",
      )}
      body={I18n.t(
        archived
          ? "js.groups.edit.help_do_unarchive"
          : "js.groups.edit.help_do_archive",
      )}
      actions={
        <>
          <button
            className="btn btn-light"
            onClick={(e) => {
              e.preventDefault();
              window?.bridge?.confirm(
                I18n.t(
                  archived
                    ? "js.groups.edit.confirm_unarchive"
                    : "js.groups.edit.confirm_archive",
                ),
                () => onArchiveGroup({ slug, archived }),
              );
            }}
          >
            {I18n.t(
              archived ? "js.groups.edit.unarchive" : "js.groups.edit.archive",
            )}
          </button>
          {can.destroy && (
            <button
              className="btn btn-danger"
              onClick={(e) => {
                e.preventDefault();
                window?.bridge?.confirm(
                  I18n.t("js.groups.edit.confirm_delete"),
                  () => onDeleteGroup({ slug }),
                );
              }}
            >
              {I18n.t("js.groups.edit.delete")}
            </button>
          )}
        </>
      }
    />
  );
}
